















import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import {
	defineComponent,
	computed,
	PropType,
} from '@vue/composition-api';

const SIZE_CLASSES = {
	[Size.TINY]: 'count-badge--tiny',
	[Size.SMALL]: 'count-badge--small',
} as Record<Size, string>;

const PLUS_SIZE_CLASSES = {
	[Size.TINY]: 'count-badge--tiny--is-wide',
	[Size.SMALL]: 'count-badge--small--is-wide',
} as Record<Size, string>;

const INNER_SIZE_CLASSES = {
	[Size.TINY]: 'count-badge--tiny__inner',
	[Size.SMALL]: 'count-badge--small__inner',
} as Record<Size, string>;

const PALETTE_CLASSES = {
	[ButtonPalettes.DEFAULT]: '',
	[ButtonPalettes.PRIMARY]: 'count-badge--blue-color',
} as Record<ButtonPalettes, string>;

export default defineComponent({
	props: {
		count: {
			type: Number,
			required: true,
		},
		max: {
			type: Number,
			default: Infinity,
		},
		ariaLabel: {
			type: String,
			required: true,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.SMALL,
			validator: (size: Size) => Object.values(Size).includes(size),
		},
		palette: {
			type: Number as PropType<ButtonPalettes>,
			default: ButtonPalettes.DEFAULT,
			validator: (palette: ButtonPalettes) => Object.values(ButtonPalettes).includes(palette),
		},
	},
	setup(props) {
		const truncatedCount = computed(() => (props.count > props.max
			? `${props.max}+`
			: props.count.toString()));

		const innerClasses = (() => ({
			'count-badge__inner': true,
			[INNER_SIZE_CLASSES[props.size]]: true,
		}));

		const isWide = computed(() => {
			switch (props.size) {
			case Size.TINY:
			case Size.SMALL:
				return truncatedCount.value.length > 1;
			default:
				return false;
			}
		});

		const classes = computed(() => ({
			'vf-label': true,
			'count-badge': true,
			[SIZE_CLASSES[props.size]]: true,
			[PLUS_SIZE_CLASSES[props.size]]: isWide.value,
			[PALETTE_CLASSES[props.palette]]: true,
		}));

		return {
			classes,
			innerClasses,
			truncatedCount,
		};
	},
});
